(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 10000;
  var DRAWER_ID  = 'fcd-drawer';
  var OVERLAY_ID = 'fcd-overlay';
  var MODAL_ID   = 'fcd-protection-modal';
  var MAX_BUSY_MS = 5000;

  // Products that should have fixed quantity (qty buttons hidden, always show as 1).
  // Add product handles here.
  var FIXED_QTY_HANDLES = [
    'manukind-tote-bag-kit-for-shopify-collecitve-only',
    'manukind-sample-pack-for-shopify-collective-only',
    'holle-organic-apple-pear-yogurt-pouches-85g',
    'holle-organic-mango-yogurt-pouch-85g'
  ];

  function isFixedQtyItem(item) {
    return item && item.handle && FIXED_QTY_HANDLES.indexOf(item.handle) !== -1;
  }

  var cart = null;
  var escListenerAdded = false;

  var isBusy = false;
  var busyItemKey = null;
  var busyTimeoutId = null;

  var optimisticQtyByKey = {};

  var pendingQtyUpdate = null;

  var lastDesiredQtyByKey = {};

  window._fcdCart = null;

  window._fcdHasPendingCartOps = function () {
    return isBusy;
  };

  function getLatestCart() {
    if (window._fcdCart && Array.isArray(window._fcdCart.items)) {
      cart = window._fcdCart;
      return cart;
    }
    return cart;
  }

  function setBusy(state, itemKey) {
    isBusy = state;
    busyItemKey = state ? (itemKey || null) : null;
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    drawer.querySelectorAll('.fcd-item.is-updating').forEach(function (el) {
      el.classList.remove('is-updating');
    });

    if (state) {
      drawer.classList.add('fcd-is-busy');
      if (itemKey) {
        var itemEl = drawer.querySelector('[data-key="' + CSS.escape(itemKey) + '"]');
        if (itemEl) itemEl.classList.add('is-updating');
      }
      if (busyTimeoutId) clearTimeout(busyTimeoutId);
      busyTimeoutId = setTimeout(function () {
        console.warn('[FCD] Busy timeout — force unlock');
        optimisticQtyByKey = {};
        isBusy = false;
        busyItemKey = null;
        drawer.classList.remove('fcd-is-busy');
        drawer.querySelectorAll('.fcd-item.is-updating').forEach(function (el) {
          el.classList.remove('is-updating');
        });
        fetchCart(function (fresh) {
          if (fresh && fresh.items) {
            var hasReal = fresh.items.some(function (i) { return !isProtection(i); });
            renderCart(fresh, false, !hasReal);
            if (typeof window.fcdInjectSubscriptions === 'function') {
              window.fcdInjectSubscriptions(true);
            }
          }
        });
      }, MAX_BUSY_MS);
    } else {
      drawer.classList.remove('fcd-is-busy');
      if (busyTimeoutId) {
        clearTimeout(busyTimeoutId);
        busyTimeoutId = null;
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function isProtection(item) {
    return item && item.sku === 'SHIP-PROTECT';
  }

  function fetchCart(cb) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && Array.isArray(data.items)) {
          cart = data;
          window._fcdCart = data;
        }
        if (cb) cb(data);
        return data;
      })
      .catch(function (e) {
        console.warn('[FCD] fetchCart error:', e);
        if (cb) cb(null);
      });
  }

  // Force any fixed-qty products in the cart back to quantity 1 (server-side
  // safety net for when a product is added more than once). Runs sequentially,
  // resolves with the latest cart. /cart/change.js is not intercepted, so no recursion.
  function correctFixedQtyItems(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return Promise.resolve(cartData);
    var toFix = cartData.items.filter(function (i) {
      return isFixedQtyItem(i) && i.quantity > 1;
    });
    if (toFix.length === 0) return Promise.resolve(cartData);
    return toFix.reduce(function (chain, line) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: 1 })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (data && Array.isArray(data.items)) {
              window._fcdCart = data;
              cart = data;
            }
          })
          .catch(function () {});
      });
    }, Promise.resolve()).then(function () {
      return window._fcdCart || cartData;
    });
  }

  function processPendingQty() {
    if (!pendingQtyUpdate) return;
    var next = pendingQtyUpdate;
    pendingQtyUpdate = null;
    handleQtyClick(next.key, next.qty);
  }

  function handleQtyClick(key, desiredQty) {
    if (isBusy) {
      pendingQtyUpdate = { key: key, qty: desiredQty };
      return;
    }

    setBusy(true, key);

    lastDesiredQtyByKey[key] = desiredQty;

    optimisticQtyByKey[key] = desiredQty;
    applyOptimisticQty(key, desiredQty);

    // If this removes the LAST real product, removing it alone would briefly
    // leave a protection-only cart, which the checkout-validation function
    // rejects (422) and jams the drawer. Clear the whole cart in one atomic
    // call instead — product and protection go together, no protection-only
    // state ever reaches the server.
    var currentCart = window._fcdCart;
    var realItemsNow = (currentCart && currentCart.items ? currentCart.items : [])
      .filter(function (i) { return !isProtection(i); });
    var removingLastReal = desiredQty === 0 &&
      realItemsNow.length === 1 &&
      realItemsNow[0].key === key;

    if (removingLastReal) {
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart clear failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          optimisticQtyByKey = {};
          cart = data;
          window._fcdCart = data;
          renderCart(data, false, true);
          setTimeout(function () { closeDrawer(); }, 600);
          delete lastDesiredQtyByKey[key];
        })
        .catch(function (e) {
          console.warn('[FCD] Cart clear error:', e);
          optimisticQtyByKey = {};
          delete lastDesiredQtyByKey[key];
          return fetchCart(function (fresh) {
            if (fresh && fresh.items) {
              var hasReal = fresh.items.some(function (i) { return !isProtection(i); });
              renderCart(fresh, false, !hasReal);
            }
          });
        })
        .finally(function () {
          setBusy(false);
          processPendingQty();
        });
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: desiredQty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.items)) {
          return fetchCart(null).then(function () { return window._fcdCart; });
        }
        cart = data;
        window._fcdCart = data;
        return data;
      })
      .then(function (updatedCart) {
        if (typeof window._fcdTriggerProtectionSync === 'function') {
          return window._fcdTriggerProtectionSync(updatedCart);
        }
        return null;
      })
      .then(function () {
        optimisticQtyByKey = {};
        var finalCart = window._fcdCart;
        if (finalCart && finalCart.items) {
          cart = finalCart;
          var hasReal = finalCart.items.some(function (i) { return !isProtection(i); });
          renderCart(finalCart, false, !hasReal);
          if (!hasReal) {
            setTimeout(function () {
              closeDrawer();
            }, 600);
          }
        }
        delete lastDesiredQtyByKey[key];
      })
      .catch(function (e) {
        console.warn('[FCD] Qty change error:', e);
        optimisticQtyByKey = {};
        delete lastDesiredQtyByKey[key];
        return fetchCart(function (fresh) {
          if (fresh && fresh.items) {
            var hasReal = fresh.items.some(function (i) { return !isProtection(i); });
            renderCart(fresh, false, !hasReal);
          }
        });
      })
      .finally(function () {
        setBusy(false);
        processPendingQty();
      });
  }

  function applyOptimisticQty(key, desiredQty) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    var itemEl = drawer.querySelector('[data-key="' + CSS.escape(key) + '"]');
    if (!itemEl) return;

    var qtyEl = itemEl.querySelector('.fcd-item__qty-num');
    if (qtyEl && qtyEl.textContent !== String(desiredQty)) {
      qtyEl.textContent = desiredQty;
    }

    var minusBtn = itemEl.querySelector('.fcd-item__qty .fcd-qty-btn:first-child');
    var plusBtn  = itemEl.querySelector('.fcd-item__qty .fcd-qty-btn:last-child');
    if (minusBtn) {
      var dec = String(desiredQty - 1);
      if (minusBtn.dataset.qty !== dec) minusBtn.dataset.qty = dec;
    }
    if (plusBtn) {
      var inc = String(desiredQty + 1);
      if (plusBtn.dataset.qty !== inc) plusBtn.dataset.qty = inc;
    }
  }

  function checkoutWithoutProtection() {
    var currentCart = getLatestCart();
    var protectionItem = currentCart && currentCart.items && currentCart.items.find(isProtection);

    window._fcdSkipProtection = true;

    var btn = document.querySelector('.fcd-checkout-no-protection');
    if (btn) {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.6';
    }

    // Set cart attribute to signal customer opted out of protection
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { protection_opted_out: 'true' } })
    }).then(function () {
      if (protectionItem) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
        })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && Array.isArray(data.items)) {
            window._fcdCart = data;
            cart = data;
          }
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = '/checkout';
        });
      } else {
        window.location.href = '/checkout';
      }
    }).catch(function () {
      window.location.href = '/checkout';
    });
  }

  function guardedCheckout(e, btnEl) {
    var currentCart = window._fcdCart;
    if (!currentCart || !currentCart.items || currentCart.items.length === 0) return;

    e.preventDefault();
    e.stopPropagation();

    var originalText = btnEl.textContent;
    btnEl.textContent = 'Finalizing cart...';
    btnEl.style.pointerEvents = 'none';
    btnEl.style.opacity = '0.7';

    function proceedAfterSettled() {
      if (typeof window._fcdEnsureProtectionSettled === 'function') {
        window._fcdEnsureProtectionSettled().then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          window.location.href = '/checkout';
        });
      } else {
        window.location.href = '/checkout';
      }
    }

    if (isBusy || pendingQtyUpdate) {
      var waited = 0;
      var waitInterval = setInterval(function () {
        waited += 50;
        if ((!isBusy && !pendingQtyUpdate) || waited > 5000) {
          clearInterval(waitInterval);
          proceedAfterSettled();
        }
      }, 50);
      return;
    }

    proceedAfterSettled();
  }

  function unlockScroll() {
    var savedY = window._fcdScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    if (savedY !== undefined) {
      window.scrollTo(0, savedY);
      window._fcdScrollY = undefined;
    }
    document.body.classList.remove('overflow-hidden','no-scroll','scroll-lock','is-locked','rebuy-cart-visible');
  }

  function lockScroll() {
    window._fcdScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + window._fcdScrollY + 'px';
    document.body.style.width = '100%';
  }

  function createProtectionModal() {
    if (document.getElementById(MODAL_ID)) return;

    var logoHtml = window.FCD_LOGO_URL
      ? '<img class="fcd-pmodal__logo" src="' + window.FCD_LOGO_URL + '" alt="Formuland">'
      : '<span class="fcd-pmodal__logo-text">Formuland</span>';

    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'fcd-pmodal';
    modal.innerHTML =
      '<div class="fcd-pmodal__backdrop"></div>' +
      '<div class="fcd-pmodal__box">' +
        '<div class="fcd-pmodal__header">' +
          logoHtml +
          '<button class="fcd-pmodal__close" aria-label="Close">✕</button>' +
        '</div>' +
        '<div class="fcd-pmodal__body">' +
          '<h2 class="fcd-pmodal__title">Checkout with confidence</h2>' +
          '<p class="fcd-pmodal__subtitle">Shop with confidence, knowing your purchases are protected every step of the way.</p>' +
          '<div class="fcd-pmodal__features">' +
            '<div class="fcd-pmodal__feature">' +
              '<div class="fcd-pmodal__feature-icon">🚚</div>' +
              '<div>' +
                '<p class="fcd-pmodal__feature-title">Delivery Guarantee</p>' +
                '<p class="fcd-pmodal__feature-desc">Your items are protected every step of the way.</p>' +
              '</div>' +
            '</div>' +
            '<div class="fcd-pmodal__feature">' +
              '<div class="fcd-pmodal__feature-icon">📦</div>' +
              '<div>' +
                '<p class="fcd-pmodal__feature-title">Package Protection</p>' +
                '<p class="fcd-pmodal__feature-desc">Lost, stolen, or damaged in transit? If not marked delivered, we\'ll send a replacement.</p>' +
              '</div>' +
            '</div>' +
            '<div class="fcd-pmodal__feature">' +
              '<div class="fcd-pmodal__feature-icon">↩️</div>' +
              '<div>' +
                '<p class="fcd-pmodal__feature-title">Easy Return Portal</p>' +
                '<p class="fcd-pmodal__feature-desc">Skip all the back and forth, and submit your return in a few clicks.</p>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<p class="fcd-pmodal__legal">By purchasing coverage, you agree and have read the ' +
            '<a href="/policies/privacy-policy" target="_blank">Privacy Policy</a> and ' +
            '<a href="/policies/terms-of-service" target="_blank">Terms and Conditions</a>. ' +
            'Coverage is subject to Merchant\'s Return Policy.' +
          '</p>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    modal.querySelector('.fcd-pmodal__backdrop').addEventListener('click', closeProtectionModal);
    modal.querySelector('.fcd-pmodal__close').addEventListener('click', closeProtectionModal);

    if (!document.getElementById('fcd-pmodal-styles')) {
      var style = document.createElement('style');
      style.id = 'fcd-pmodal-styles';
      style.textContent =
        '.fcd-pmodal{display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;}' +
        '.fcd-pmodal.is-open{display:block;}' +
        '.fcd-pmodal__backdrop{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.65);}' +
        '.fcd-pmodal__box{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;border-radius:16px;width:calc(100vw - 40px);max-width:420px;max-height:calc(100vh - 60px);overflow-y:auto;overflow-x:hidden;box-shadow:0 24px 80px rgba(0,0,0,0.35);display:flex;flex-direction:column;}' +
        '.fcd-pmodal__header{background:#1f5c35;border-radius:16px 16px 0 0;padding:18px 52px;text-align:center;position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;min-height:68px;}' +
        '.fcd-pmodal__logo{max-height:40px;max-width:180px;object-fit:contain;filter:brightness(0) invert(1);}' +
        '.fcd-pmodal__logo-text{color:#fff;font-size:20px;font-weight:700;letter-spacing:0.5px;}' +
        '.fcd-pmodal__close{position:absolute;top:50%;right:12px;transform:translateY(-50%);background:rgba(255,255,255,0.2);border:none;font-size:14px;cursor:pointer;color:#fff;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;}' +
        '.fcd-pmodal__close:hover{background:rgba(255,255,255,0.4);}' +
        '.fcd-pmodal__body{padding:24px 20px 24px;flex:1;}' +
        '.fcd-pmodal__title{font-size:17px;font-weight:700;color:#1a1a1a;margin:0 0 8px;text-align:center;}' +
        '.fcd-pmodal__subtitle{font-size:13px;color:#666;margin:0 0 20px;line-height:1.6;text-align:center;}' +
        '.fcd-pmodal__features{display:flex;flex-direction:column;gap:12px;margin-bottom:20px;}' +
        '.fcd-pmodal__feature{display:flex;align-items:flex-start;gap:12px;padding:12px;background:#f7faf8;border-radius:10px;}' +
        '.fcd-pmodal__feature-icon{font-size:20px;line-height:1;flex-shrink:0;margin-top:2px;}' +
        '.fcd-pmodal__feature-title{font-size:13px;font-weight:600;color:#1a1a1a;margin:0 0 4px;}' +
        '.fcd-pmodal__feature-desc{font-size:12px;color:#666;margin:0;line-height:1.5;}' +
        '.fcd-pmodal__legal{font-size:11px;color:#6b6b6b;line-height:1.6;margin:0;border-top:1px solid #eee;padding-top:16px;}' +
        '.fcd-pmodal__legal a{color:#1f5c35;text-decoration:underline;}' +
        '.fcd-protection__info-btn{background:none;border:1.5px solid #1f5c35;border-radius:50%;cursor:pointer;padding:0;margin-left:5px;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;color:#1f5c35;width:15px;height:15px;flex-shrink:0;line-height:1;}' +
        '.fcd-protection__info-btn:hover{background:#1f5c35;color:#fff;}' +
        '.fcd-protection__info-btn svg{width:8px;height:8px;fill:currentColor;}' +
        '.fcd-drawer .fcd-body{scrollbar-gutter:stable;overflow-y:auto;overflow-x:hidden;}' +
        '.fcd-drawer{scrollbar-gutter:stable;}' +
        '.fcd-item__qty-num,.fcd-item__price,.fcd-subtotal__price,.fcd-protection__price{transition:color 0.2s ease;}' +
        '.fcd-qty-btn{transition:transform 0.08s ease, background-color 0.15s ease, opacity 0.2s ease;-webkit-tap-highlight-color:transparent;}' +
        '.fcd-qty-btn:active{transform:scale(0.92);}' +
        '.fcd-checkout-btn{transition:opacity 0.2s ease, transform 0.08s ease;}' +
        '.fcd-checkout-btn:active{transform:scale(0.98);}' +
        '.fcd-drawer.fcd-is-busy .fcd-qty-btn{pointer-events:none;}' +
        '.fcd-drawer.fcd-is-busy .fcd-checkout-btn{pointer-events:none;opacity:0.75;}' +
        '.fcd-item.is-updating .fcd-item__qty{position:relative;}' +
        '.fcd-item.is-updating .fcd-item__qty .fcd-qty-btn,' +
        '.fcd-item.is-updating .fcd-item__qty .fcd-item__qty-num{opacity:0.15;transition:opacity 0.15s ease;}' +
        '.fcd-item.is-updating .fcd-item__qty::after{' +
          'content:"";' +
          'position:absolute;' +
          'top:50%;left:50%;' +
          'width:18px;height:18px;' +
          'margin:-9px 0 0 -9px;' +
          'border:2px solid rgba(31,92,53,0.2);' +
          'border-top-color:#1f5c35;' +
          'border-radius:50%;' +
          'animation:fcdSpin 0.65s linear infinite;' +
          'z-index:2;' +
        '}' +
        '.fcd-item.is-updating .fcd-item__price{opacity:0.5;}' +
        '.fcd-item.is-updating .fcd-item__remove{opacity:0.5;pointer-events:none;}' +
        '.fcd-drawer.fcd-is-busy .fcd-subtotal__price,' +
        '.fcd-drawer.fcd-is-busy .fcd-protection__price{' +
          'opacity:0.5;' +
          'transition:opacity 0.2s ease;' +
        '}' +
        '@keyframes fcdSpin{to{transform:rotate(360deg);}}';
      document.head.appendChild(style);
    }
  }

  function openProtectionModal() {
    createProtectionModal();
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    document.body.appendChild(modal);
    modal.classList.add('is-open');
  }

  function closeProtectionModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.classList.remove('is-open');
  }

  function buildShippingBar(totalPrice) {
    var percent   = Math.min(100, Math.round((totalPrice / FREE_SHIPPING_THRESHOLD) * 100));
    var remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    var message   = totalPrice >= FREE_SHIPPING_THRESHOLD
      ? '<strong>🎉 Congrats! You\'ve unlocked FREE SHIPPING!</strong>'
      : 'You are <strong>' + formatMoney(remaining) + '</strong> away from FREE SHIPPING!';
    return '<div class="fcd-shipping-bar">' +
      '<div class="fcd-shipping-bar__track"><div class="fcd-shipping-bar__fill" style="width:' + percent + '%"></div></div>' +
      '<p class="fcd-shipping-bar__text">' + message + '</p>' +
    '</div>';
  }

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildItem(item) {
    if (isProtection(item)) return '';
    var img     = escHtml(item.image || '');
    var price   = formatMoney(item.final_line_price);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var subText = item.selling_plan_allocation
      ? '<p class="fcd-item__subscription">♻ ' + escHtml(item.selling_plan_allocation.selling_plan.name) + '</p>'
      : '';
    var displayQty = optimisticQtyByKey[item.key] !== undefined ? optimisticQtyByKey[item.key] : item.quantity;
    var qtyMarkup = isFixedQtyItem(item)
      ? '<div class="fcd-item__qty fcd-item__qty--fixed">' +
          '<span class="fcd-item__qty-static">Qty: ' + item.quantity + '</span>' +
        '</div>'
      : '<div class="fcd-item__qty">' +
          '<button class="fcd-item__qty-btn fcd-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="' + (displayQty - 1) + '">−</button>' +
          '<span class="fcd-item__qty-num">' + displayQty + '</span>' +
          '<button class="fcd-item__qty-btn fcd-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="' + (displayQty + 1) + '">+</button>' +
        '</div>';
    return '<div class="fcd-item" data-key="' + escHtml(item.key) + '" data-variant-id="' + escHtml(item.variant_id) + '">' +
      '<img class="fcd-item__img" src="' + img + '" alt="' + escHtml(item.product_title) + '" loading="lazy">' +
      '<div class="fcd-item__info">' +
        '<a class="fcd-item__title" href="/products/' + escHtml(item.handle) + '">' + escHtml(item.product_title) + '</a>' +
        (variant ? '<p class="fcd-item__variant">' + escHtml(variant) + '</p>' : '') +
        subText +
        
        '<div class="fcd-item__price-row">' +
  '<div class="fcd-item__price-group">' +
    '<span class="fcd-item__price">' + price + '</span>' +
    '<button class="fcd-item__remove fcd-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="0">Remove</button>' +
  '</div>' +
  qtyMarkup +
'</div>' +
        '</div>' +
    '</div>';
  }

  var INFO_ICON =
    '<svg viewBox="0 0 10 14" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="3.5" y="4" width="3" height="10" rx="1.5"/>' +
      '<rect x="3.5" y="0" width="3" height="3" rx="1.5"/>' +
    '</svg>';

  function buildShippingProtection(item) {
    if (!item) return '';
    var price = formatMoney(item.line_price);
    var icon  = window.FCD_PROTECTION_ICON
      ? '<img src="' + escHtml(window.FCD_PROTECTION_ICON) + '" alt="Protection" style="width:40px;height:40px;object-fit:contain;">'
      : '🛡';
    return '<div class="fcd-protection">' +
      '<div class="fcd-protection__icon">' + icon + '</div>' +
      '<div class="fcd-protection__info">' +
        '<p class="fcd-protection__title">' +
          'Delivery Guarantee' +
          '<button class="fcd-protection__info-btn" aria-label="Learn more about Delivery Guarantee">' + INFO_ICON + '</button>' +
        '</p>' +
        '<p class="fcd-protection__desc">Free returns + package protection</p>' +
      '</div>' +
      '<span class="fcd-protection__price">' + price + '</span>' +
    '</div>';
  }

  function buildFooter(protectionItem, totalPrice) {
    return buildShippingProtection(protectionItem) +
      '<div class="fcd-subtotal">' +
        '<span class="fcd-subtotal__label">Subtotal</span>' +
        '<span class="fcd-subtotal__price">' + formatMoney(totalPrice) + '</span>' +
      '</div>' +
      '<a href="/checkout" class="fcd-checkout-btn">CHECKOUT • ' + formatMoney(totalPrice) + '</a>' +
      (protectionItem
        ? '<button class="fcd-checkout-no-protection">Checkout without Delivery Guarantee</button>'
        : '');
  }

  function buildEmpty() {
    return '<div class="fcd-empty"><p>Your cart is empty</p><a href="/collections/all">Shop Now</a></div>';
  }

  var lastCartHandles = '';
  var lastRenderedSig = '';

  function cartRenderSig(data) {
    if (!data || !data.items) return '';
    var sig = data.items.map(function (i) {
      return i.key + ':' + i.quantity + ':' + i.final_line_price;
    }).join(',') + '|' + data.total_price;
    return sig;
  }

  function setText(el, value) {
    if (!el) return;
    if (el.textContent !== value) el.textContent = value;
  }

  function reconcileSubBadge(itemEl, item) {
    if (!itemEl) return;
    var existing = itemEl.querySelector('.fcd-item__subscription');
    if (item.selling_plan_allocation) {
      var planName = item.selling_plan_allocation.selling_plan.name;
      var newText = '♻ ' + planName;
      if (existing) {
        if (existing.textContent !== newText) existing.textContent = newText;
        return;
      }
      var infoEl = itemEl.querySelector('.fcd-item__info');
      if (!infoEl) return;
      var badge = document.createElement('p');
      badge.className = 'fcd-item__subscription';
      badge.textContent = newText;
      var variantEl = infoEl.querySelector('.fcd-item__variant');
      var titleEl   = infoEl.querySelector('.fcd-item__title');
      var priceRow  = infoEl.querySelector('.fcd-item__price-row');
      if (variantEl && variantEl.parentNode === infoEl) {
        variantEl.insertAdjacentElement('afterend', badge);
      } else if (titleEl && titleEl.parentNode === infoEl) {
        titleEl.insertAdjacentElement('afterend', badge);
      } else if (priceRow && priceRow.parentNode === infoEl) {
        infoEl.insertBefore(badge, priceRow);
      } else {
        infoEl.appendChild(badge);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function renderCart(rawData, allowSubInject, explicitEmpty) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer || !rawData) return;
    if (!rawData.items || !Array.isArray(rawData.items)) return;

    var data = rawData;

    var sig = cartRenderSig(data);
    if (sig && sig === lastRenderedSig && !allowSubInject && !explicitEmpty) return;
    lastRenderedSig = sig;

    var bodyForScroll = drawer.querySelector('.fcd-body');
    var savedScroll = bodyForScroll ? bodyForScroll.scrollTop : 0;

    cart = rawData;
    window._fcdCart = rawData;

    var allItems       = data.items || [];
    var realItems      = allItems.filter(function (i) { return !isProtection(i); });
    var protectionItem = allItems.find(isProtection);
    var isEmpty        = realItems.length === 0;

    if (isEmpty && !explicitEmpty) {
      var itemsWrapCheck = drawer.querySelector('.fcd-items-wrap');
      if (itemsWrapCheck && itemsWrapCheck.dataset.keys && itemsWrapCheck.dataset.keys !== '') return;
    }

    var fillEl = drawer.querySelector('.fcd-shipping-bar__fill');
    var textEl = drawer.querySelector('.fcd-shipping-bar__text');
    if (fillEl && textEl) {
      var percent   = Math.min(100, Math.round((data.total_price / FREE_SHIPPING_THRESHOLD) * 100));
      var remaining = FREE_SHIPPING_THRESHOLD - data.total_price;
      var newWidth  = percent + '%';
      if (fillEl.style.width !== newWidth) fillEl.style.width = newWidth;
      var newMsg = data.total_price >= FREE_SHIPPING_THRESHOLD
        ? '<strong>🎉 Congrats! You\'ve unlocked FREE SHIPPING!</strong>'
        : 'You are <strong>' + formatMoney(remaining) + '</strong> away from FREE SHIPPING!';
      if (textEl.innerHTML !== newMsg) textEl.innerHTML = newMsg;
    }

    var itemsWrap = drawer.querySelector('.fcd-items-wrap');
    var emptyWrap = drawer.querySelector('.fcd-empty-wrap');
    var itemsChanged = false;

    if (itemsWrap) {
      var newKeys = realItems.map(function (i) {
        return i.key + ':' + i.quantity + ':' + i.final_line_price;
      }).join(',');
      var oldKeys = itemsWrap.dataset.keys || '';

      if (isEmpty) {
        if (oldKeys !== '' || itemsWrap.children.length > 0) {
          itemsWrap.innerHTML = '';
          itemsWrap.dataset.keys = '';
          itemsChanged = true;
        }
        if (emptyWrap && !emptyWrap.firstChild) {
          emptyWrap.innerHTML = buildEmpty();
        }
      } else {
        if (emptyWrap && emptyWrap.firstChild) {
          emptyWrap.innerHTML = '';
        }

        if (newKeys === oldKeys) {
          realItems.forEach(function (item) {
            var itemEl = itemsWrap.querySelector('[data-key="' + CSS.escape(item.key) + '"]');
            reconcileSubBadge(itemEl, item);
          });
        } else {
          var oldItemKeys = oldKeys.split(',').map(function (s) { return s.split(':')[0]; }).filter(Boolean);
          var newItemKeys = realItems.map(function (i) { return i.key; });
          var sameItems = oldKeys !== '' &&
            oldItemKeys.length === newItemKeys.length &&
            newItemKeys.every(function (k) { return oldItemKeys.indexOf(k) !== -1; });

          if (sameItems) {
            realItems.forEach(function (item) {
              var itemEl = itemsWrap.querySelector('[data-key="' + CSS.escape(item.key) + '"]');
              if (!itemEl) return;
              var displayQty = optimisticQtyByKey[item.key] !== undefined ? optimisticQtyByKey[item.key] : item.quantity;
              var priceEl = itemEl.querySelector('.fcd-item__price');
              var qtyEl   = itemEl.querySelector('.fcd-item__qty-num');
              var staticQtyEl = itemEl.querySelector('.fcd-item__qty-static');
              var minusBtn = itemEl.querySelector('.fcd-item__qty .fcd-qty-btn:first-child');
              var plusBtn  = itemEl.querySelector('.fcd-item__qty .fcd-qty-btn:last-child');
              setText(priceEl, formatMoney(item.final_line_price));
              setText(qtyEl, String(displayQty));
              if (staticQtyEl) setText(staticQtyEl, 'Qty: ' + item.quantity);
              if (minusBtn) {
                var dec = String(displayQty - 1);
                if (minusBtn.dataset.qty !== dec) minusBtn.dataset.qty = dec;
              }
              if (plusBtn) {
                var inc = String(displayQty + 1);
                if (plusBtn.dataset.qty !== inc) plusBtn.dataset.qty = inc;
              }
              reconcileSubBadge(itemEl, item);
            });
          } else {
            itemsWrap.innerHTML = realItems.map(buildItem).join('');
            itemsChanged = true;
            if (typeof window.fcdInjectSubscriptions === 'function') {
              window.fcdInjectSubscriptions(true);
            }
          }
        }
        itemsWrap.dataset.keys = newKeys;
      }
    }

    var footer = drawer.querySelector('.fcd-footer');
    if (footer) {
      var subtotalEl = footer.querySelector('.fcd-subtotal__price');
      var checkoutEl = footer.querySelector('.fcd-checkout-btn');
      var protEl     = footer.querySelector('.fcd-protection__price');
      var hasProtEl  = !!protEl;
      var needsProt  = !!protectionItem;

      if (hasProtEl !== needsProt) {
        footer.innerHTML = buildFooter(protectionItem, data.total_price);
        attachFooterListeners();
      } else {
        setText(subtotalEl, formatMoney(data.total_price));
        setText(checkoutEl, 'CHECKOUT • ' + formatMoney(data.total_price));
        if (protEl && protectionItem) {
          setText(protEl, formatMoney(protectionItem.line_price));
        }
      }
    }

    if (bodyForScroll && savedScroll > 0 && bodyForScroll.scrollTop !== savedScroll) {
      bodyForScroll.scrollTop = savedScroll;
    }

    if (document.body.classList.contains('rebuy-cart-visible') ||
        document.querySelector('.rebuy-cart__overlay, .rebuy-cart__flyout')) {
      killRebuy();
    }

    updateCartCount(realItems.reduce(function (sum, i) { return sum + i.quantity; }, 0));

    if (allowSubInject && itemsChanged && !window._fcdSubInjectPending) {
      window._fcdSubInjectPending = true;
      setTimeout(function () {
        window._fcdSubInjectPending = false;
        if (typeof window.fcdInjectSubscriptions === 'function') {
          window.fcdInjectSubscriptions(true);
        }
      }, 200);
    }

    var uniqueHandles = {};
    realItems.forEach(function (i) { uniqueHandles[i.handle] = true; });
    var currentHandles = Object.keys(uniqueHandles).sort().join(',');
    if (currentHandles !== lastCartHandles) {
      lastCartHandles = currentHandles;
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('fcd:cart:handles:changed'));
      }, 150);
    }
  }

  function attachFooterListeners() {
    var noProtBtn = document.querySelector('.fcd-checkout-no-protection');
    if (noProtBtn && !noProtBtn.dataset.fcdBound) {
      noProtBtn.dataset.fcdBound = '1';
      noProtBtn.addEventListener('click', checkoutWithoutProtection);
    }

    var infoBtn = document.querySelector('.fcd-protection__info-btn');
    if (infoBtn && !infoBtn.dataset.fcdBound) {
      infoBtn.dataset.fcdBound = '1';
      infoBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openProtectionModal();
      });
    }

    var checkoutBtn = document.querySelector('.fcd-checkout-btn');
    if (checkoutBtn && !checkoutBtn.dataset.fcdBound) {
      checkoutBtn.dataset.fcdBound = '1';
      checkoutBtn.addEventListener('click', function (e) {
        guardedCheckout(e, checkoutBtn);
      });
    }
  }

  window.fcdRenderCart = function (cartData) {
    if (cartData && cartData.items && Array.isArray(cartData.items)) {
      cart = cartData;
      window._fcdCart = cartData;
      var hasReal = cartData.items.some(function (i) { return !isProtection(i); });
      renderCart(cartData, false, !hasReal);
    } else {
      fetchCart(function (data) {
        if (data && data.items) {
          var hasReal2 = data.items.some(function (i) { return !isProtection(i); });
          renderCart(data, false, !hasReal2);
        }
      });
    }
  };

  var bodyDelegationAttached = false;
  function attachBodyDelegation(body) {
    if (bodyDelegationAttached) return;
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('.fcd-qty-btn');
      if (!btn || !body.contains(btn)) return;
      if (!btn.closest('.fcd-items-wrap')) return;
      if (isBusy && !pendingQtyUpdate) {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        if (!key || isNaN(qty) || qty < 0) return;
        pendingQtyUpdate = { key: key, qty: qty };
        return;
      }
      var key2 = btn.dataset.key;
      var qty2 = parseInt(btn.dataset.qty, 10);
      if (!key2 || isNaN(qty2) || qty2 < 0) return;
      handleQtyClick(key2, qty2);
    });
    bodyDelegationAttached = true;
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble span:first-child, .cart-icon-bubble span, [data-cart-count]').forEach(function (el) {
      var s = String(count);
      if (el.textContent !== s) el.textContent = s;
    });
  }

  function killRebuy() {
    ['.rebuy-cart__overlay','.rebuy-cart__background','.rebuy-cart__cover','.rebuy-cart__flyout'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.style.display !== 'none') {
          el.style.cssText = 'display:none!important';
        }
      });
    });
    if (document.body.classList.contains('rebuy-cart-visible')) {
      document.body.classList.remove('rebuy-cart-visible');
    }
  }

  function watchRebuy() {
    var obs = new MutationObserver(function (mutations) {
      var needsKill = mutations.some(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          return m.target === document.body && document.body.classList.contains('rebuy-cart-visible');
        }
        if (m.type === 'childList') {
          return Array.from(m.addedNodes).some(function (n) {
            return n.nodeType === 1 && n.className && typeof n.className === 'string' && (
              n.className.indexOf('rebuy-cart__overlay') !== -1 ||
              n.className.indexOf('rebuy-cart__flyout') !== -1
            );
          });
        }
        return false;
      });
      if (needsKill) killRebuy();
    });
    obs.observe(document.body, {
      childList: true, subtree: false,
      attributes: true, attributeFilter: ['class']
    });
  }

  function createDrawer() {
    if (document.getElementById(DRAWER_ID)) return;

    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'fcd-overlay';
    overlay.addEventListener('click', closeDrawer);
    document.body.appendChild(overlay);

    var drawer = document.createElement('div');
    drawer.id = DRAWER_ID;
    drawer.className = 'fcd-drawer';
    drawer.innerHTML =
      '<div class="fcd-header">' +
        '<p class="fcd-header__title">Your Cart</p>' +
        '<div class="fcd-header__actions">' +
          '<a href="/account/login" class="fcd-login-btn">Login</a>' +
          '<button class="fcd-close-btn" id="fcd-close">✕</button>' +
        '</div>' +
      '</div>' +
      buildShippingBar(0) +
      '<div class="fcd-body">' +
        '<div class="fcd-empty-wrap"></div>' +
        '<div class="fcd-items-wrap fcd-items"></div>' +
        '<div class="fcd-extras"></div>' +
      '</div>' +
      '<div class="fcd-footer">' +
        '<div class="fcd-subtotal"><span class="fcd-subtotal__label">Subtotal</span><span class="fcd-subtotal__price">$0</span></div>' +
        '<a href="/checkout" class="fcd-checkout-btn">CHECKOUT</a>' +
      '</div>';

    document.body.appendChild(drawer);
    document.getElementById('fcd-close').addEventListener('click', closeDrawer);

    var body = drawer.querySelector('.fcd-body');
    if (body) attachBodyDelegation(body);

    if (!escListenerAdded) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDrawer();
          closeProtectionModal();
        }
      });
      escListenerAdded = true;
    }
  }

  function openDrawer(cartData) {
    if (!window._fcdUserOpenedCart) {
      if (cartData && cartData.items) { cart = cartData; window._fcdCart = cartData; }
      return;
    }

    var drawer  = document.getElementById(DRAWER_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (!drawer) {
      createDrawer();
      drawer  = document.getElementById(DRAWER_ID);
      overlay = document.getElementById(OVERLAY_ID);
    }

    if (cartData && cartData.items) {
      cart = cartData;
      window._fcdCart = cartData;
      var hasRealOpen = cartData.items.some(function (i) { return !isProtection(i); });
      renderCart(cartData, true, !hasRealOpen);
    } else {
      var latest = getLatestCart();
      if (latest && latest.items) {
        var hasRealLatest = latest.items.some(function (i) { return !isProtection(i); });
        renderCart(latest, true, !hasRealLatest);
      }
      fetchCart(function (fresh) {
        if (!fresh || !fresh.items) return;
        var hasRealFresh = fresh.items.some(function (i) { return !isProtection(i); });
        renderCart(fresh, false, !hasRealFresh);
      });
    }

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    lockScroll();
    if (document.body.classList.contains('rebuy-cart-visible')) killRebuy();
  }

  function closeDrawer() {
    var drawer  = document.getElementById(DRAWER_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (drawer)  drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    lastRenderedSig = '';
    unlockScroll();
  }

  function isCartTrigger(el) {
    var cartLink = el.closest('a[href="/cart"]');
    if (cartLink && cartLink.closest('header,.header,.site-header,.header__wrapper,.header__icons')) return true;
    return !!el.closest('[data-drawer-trigger="drawer-cart"],[data-drawer-toggle="drawer-cart"],[data-open-drawer="drawer-cart"],.js-drawer-open-cart,[data-cart-toggle],.cart-icon-bubble,[data-testid="cart-icon-bubble"]');
  }

  function hijackCartTriggers() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('a[href="/checkout"],.fcd-checkout-btn')) return;
      if (e.target.closest('.fcd-checkout-no-protection')) return;
      if (e.target.closest('.fcd-protection__info-btn')) return;
      if (e.target.closest('#' + DRAWER_ID)) return;
      // Any programmatic click on a /cart link counts too (e.g. the cart link
      // inside the mobile menu drawer, which sits outside <header>).
      var synthCartLink = !e.isTrusted && !!e.target.closest('a[href="/cart"]');
      if (!isCartTrigger(e.target) && !synthCartLink) return;

      // Programmatic click (not from the user). The theme's product form does
      // `a[data-drawer-toggle="drawer-cart"].click()` ~2.5s after an add; on
      // mobile that link points to /cart and would navigate away from the
      // already-open drawer. Swallow it — never let it change the page.
      if (!e.isTrusted) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      window._fcdUserOpenedCart = true;
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }, true);
  }

  function suppressThemeDrawer() {
    var themeOpenEvents = [
      'theme:cart:open', 'cart:open', 'drawer:open', 'cart-drawer:open',
      'theme:drawer:open', 'on:cart:open'
    ];
    themeOpenEvents.forEach(function (evtName) {
      document.addEventListener(evtName, function (e) {
        if (window._fcdUserOpenedCart) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }, true);
    });

    var themeSelectors = [
      '#CartDrawer', '#cart-drawer', '.cart-drawer', '.drawer--cart',
      '[data-cart-drawer]', 'cart-drawer', '.js-drawer-cart'
    ];
    function killThemeDrawer() {
      themeSelectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.id === DRAWER_ID) return;
          if (el.classList.contains('active') ||
              el.classList.contains('is-open') ||
              el.classList.contains('open') ||
              el.getAttribute('aria-hidden') === 'false' ||
              el.style.transform === 'translateX(0px)' ||
              el.style.transform === 'translateX(0%)') {
            el.classList.remove('active','is-open','open');
            el.setAttribute('aria-hidden','true');
            el.style.display = 'none';
          }
        });
      });
      ['.cart-drawer__overlay', '.drawer__overlay', '.js-overlay-drawer-cart',
       '#CartDrawer-Overlay', '.modal-overlay'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.id === OVERLAY_ID) return;
          el.style.display = 'none';
        });
      });
      ['drawer-open','cart-open','js-drawer-open','js-drawer-open-cart',
       'overflow-hidden-mobile','cart-drawer-open'].forEach(function (cls) {
        if (document.body.classList.contains(cls) && window._fcdUserOpenedCart) {
          document.body.classList.remove(cls);
        }
      });
    }

    var obs = new MutationObserver(function () {
      if (window._fcdUserOpenedCart) killThemeDrawer();
    });
    obs.observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class','style','aria-hidden']
    });
  }

  function interceptAddToCart() {
    var originalFetch = window.fetch;
    window.fetch = function (url, options) {
      var result = originalFetch.apply(this, arguments);

      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      if (urlStr.indexOf('/cart/add') !== -1) {
        var method = (options && options.method && options.method.toUpperCase()) || 'GET';
        if (method === 'POST') {
          window._fcdSkipProtection = false;
          window._fcdUserOpenedCart = true;
          result.then(function (response) {
            if (!response || !response.ok) return;
            try {
              var clone = response.clone();
              clone.json().then(function () {
                var recentGesture = window._fcdLastUserGesture &&
                                    (Date.now() - window._fcdLastUserGesture) < 5000;
                if (recentGesture) {
                  setBusy(true);
                  fetchCart(function (fullCart) {
                    if (fullCart && fullCart.items) {
                      correctFixedQtyItems(fullCart).then(function (correctedCart) {
                        var useCart = (correctedCart && correctedCart.items) ? correctedCart : fullCart;
                        openDrawer(useCart);
                        if (typeof window._fcdTriggerProtectionSync === 'function') {
                          window._fcdTriggerProtectionSync(useCart).then(function () {
                            var finalCart = window._fcdCart;
                            if (finalCart && finalCart.items) {
                              cart = finalCart;
                              var hasRealAdd = finalCart.items.some(function (i) { return !isProtection(i); });
                              renderCart(finalCart, false, !hasRealAdd);
                            }
                            setBusy(false);
                          }).catch(function () {
                            setBusy(false);
                          });
                        } else {
                          setBusy(false);
                        }
                      });
                    } else {
                      setBusy(false);
                    }
                  });
                } else {
                  fetchCart(function (fullCart) {
                    correctFixedQtyItems(fullCart).then(function () {
                      if (typeof window._fcdTriggerProtectionSync === 'function') {
                        window._fcdTriggerProtectionSync();
                      }
                    });
                  });
                }
              }).catch(function () {});
            } catch (e) {}
          }).catch(function () {});
        }
      }

      return result;
    };
  }

  function trackUserGestures() {
    ['click', 'touchend'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        window._fcdLastUserGesture = Date.now();
      }, true);
    });
  }

  function init() {
    createDrawer();
    createProtectionModal();
    hijackCartTriggers();
    suppressThemeDrawer();
    trackUserGestures();
    interceptAddToCart();
    fetchCart(null);
    watchRebuy();
    document.addEventListener('cart:refresh', function () {
      if (window._fcdUserOpenedCart) openDrawer();
    });
    document.addEventListener('theme:cart:change', function (e) {
      var updated = e.detail && e.detail.cart;
      if (updated && updated.items) {
        var hasRealEv = updated.items.some(function (i) { return !isProtection(i); });
        renderCart(updated, false, !hasRealEv);
      }
      else { fetchCart(function (data) {
        if (data && data.items) {
          var hasRealEv2 = data.items.some(function (i) { return !isProtection(i); });
          renderCart(data, false, !hasRealEv2);
        }
      }); }
    });
    unlockScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
